import React from "react";
import { DirectionCard } from "../utils/DirectionCard";
import psychologyImage from "../img/Поиск-себя.png";
import educationImage from "../img/Потенциал.png";
import dependencies from "../img/Зависимости.png";

export const PsychologyServices = () => {
  const psychologyServices = [
    {
      description: "Самопознание и самореализация; поиск, раскрытие и развитие себя, своих талантов, явных и скрытых ресурсов и потенциалов; обретение себя истинного, настоящего.",
      image: psychologyImage,
    },
    {
      description: "Освобождение от эмоциональных переживаний, негативных программ, убеждений, тревожности, страхов, чувства вины, беспомощности, эмоционального выгорания.",
      image: educationImage,
    },
    {
      description:
        "Избавление от разного рода зависимостей и созависимостей – алкоголизма, наркомании, игромании, табакокурения, любовной зависимости, неудовлетворённости браком, изменами, скверным характером, разводами и т.п.",
      image: dependencies,
    },
  ];

  return (
    <section id="services" className="about-section">
      <div className="container">
        <div className="section-title text-center">
          <h2>Психология</h2>
          <div className="education-extra-text psychology-extra-text">
            <p>
              В нашем Центре мы используем проверенные временем, научно обоснованные авторские методики, которые помогают людям достигать глубинного самопознания и самореализации. 
              Вот три ключевых направления нашей работы:
            </p>
          </div>
        </div>

        <div className="card-grid">
          {psychologyServices.map((item, index) => (
            <DirectionCard
              key={index}
              title={item.title}
              description={item.description}
              image={item.image}
              showButton={false}
              hideTitle={true}
            />
          ))}
        </div>

        <div className="education-extra-text psychology-extra-text">
          <p>
            Психология – это не просто наука, это путь к познанию себя, обретению гармонии в жизни. Мы готовы поддержать вас на этом пути, предложить индивидуальные решения для каждой ситуации.
            <br />
            <br/>
            Индивидуальная консультация - <strong>3 000 ₽</strong>
            <br/>
            Семейная консультация - <strong>4 000 ₽</strong>
            <br/>
            Бизнес консультация - <strong>5 000 ₽</strong>
            <br />
            <br/>
            <strong>Запишитесь на консультацию уже сегодня, сделайте первый шаг к изменениям!</strong>
          </p>
        </div>
      </div>
    </section>
  );
};
